import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InvestigationFormRepository } from '../../../infrastructure/repositories/investigation-form.repository';
import { InvestigationFormDetailEntity } from '../../../domain/entities/investigation-form-detail.entity';
import { InvestigationFormFieldType } from '../../../domain/entities/investigation-form-field.entity';
import { GetInvestigationFormVersionByIdQuery } from './get-investigation-form-version-by-id.query';

@Injectable({ providedIn: 'root' })
export class GetInvestigationFormVersionByIdUseCase {
  private readonly _repository = inject(InvestigationFormRepository);

  public execute(query: GetInvestigationFormVersionByIdQuery): Observable<InvestigationFormDetailEntity> {
    return this._repository.getInvestigationFormVersionDetailByVersionId(query.versionId.toString()).pipe(
      map((dto) => {
        const entity = new InvestigationFormDetailEntity();
        entity.id = dto.versionId;
        entity.versionId = dto.versionId;
        entity.versionNumber = dto.versionNumber;
        entity.status = dto.status;
        entity.statusName = dto.statusName;
        entity.name = '';
        entity.displayName = '';
        entity.description = '';
        entity.investigationTypeId = dto.formId;
        entity.investigationTypeName = '';
        entity.createdAt = new Date();
        entity.updatedAt = new Date();
        entity.createdBy = '';
        entity.updatedBy = '';
        entity.fields = dto.fields.map((field) => ({
          id: field.fieldId,
          name: field.label,
          fieldType: field.fieldType as InvestigationFormFieldType,
          label: field.label,
          helperText: field.helperText ?? undefined,
          placeholder: field.placeholder ?? undefined,
          isRequired: field.isRequired,
          isVisibleToRequester: field.isVisibleToRequester,
          sensitivityCategory: field.sensitivityCategory ?? undefined,
          visibilityRule: field.visibilityRule ?? undefined,
          isHiddenByDefault: field.isHiddenByDefault,
          isSystem: field.isSystem,
          sortOrder: field.sortOrder,
          constraints: field.constraints.map((c) => ({
            typeConstraintId: '0',
            constraintKey: c.constraintKey,
            value: c.value,
            label: c.constraintKey,
            valueType: 'string',
            defaultValue: null,
          })),
        }));
        return entity;
      })
    );
  }
}
